<template>
  <div class="wrapper p-3 mb-5">
    <div
      block
      v-b-toggle.filter-coal-auxiliary
      class="text-decoration-none"
      @click="isOpen = !isOpen"
    >
      <b>Filter</b>
      <fa-icon
        class="ml-2"
        :icon="isOpen ? 'caret-down' : 'caret-right'"
      />
    </div>
    <b-collapse
      id="filter-coal-auxiliary"
    >
      <b-row class="mt-3" align-v="center">
        <b-col cols="6">
          <b-form-group
            label="Period"
            label-size="sm"
          >
            <date-picker
              class="w-100"
              placeholder="Select Period"
              v-model="periode"
              valueType="YYYY-MM-DD"
              format="YYYY-MM-DD"
              range
              @change="applyFilter"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Contractor"
            label-size="sm"
          >
            <v-select
              v-model="contractor_id"
              placeholder="Select Contractor"
              :options="options.contractors"
              label="name"
              :reduce="({ id }) => id"
              @input="applyFilter"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="d-flex justify-content-end align-items-center">
            <b-button
              class="btn-custom"
              variant="info"
              size="sm"
              @click="resetFilter"
            >
              Reset
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        companies: [],
        contractors: []
      })
    }
  },
  components: {
    DatePicker
  },
  data: () => ({
    isOpen: false,
    contractor_id: null,
    periode: []
  }),
  methods: {
    applyFilter() {
      this.$emit('apply', { contractor_id: this.contractor_id, periode: this.periode })
    },
    resetFilter() {
      this.contractor_id = null
      this.periode = []
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #DBF9F6;
  border-radius: 16px;
}
</style>
